module.exports = __webpack_public_path__ + "img/kjsy_gallery6.bec85fa9.jpg";